const handleEmbed = (container, activate) => {
  const embeds = container.querySelectorAll('iframe, script');

  embeds.length &&
    embeds.forEach(embed => {
      if (activate && embed.dataset.src) {
        embed.setAttribute('src', embed.dataset.src);
      } else if (!activate) {
        embed.removeAttribute('src');
      }
    });
};

export { handleEmbed };
